export function isExistInPath(paths: string[], url: string): boolean {
	return paths.some((item) => url.includes(item));
}
